import { render, staticRenderFns } from "./Sidebyside.vue?vue&type=template&id=3ba0e861"
import script from "./Sidebyside.vue?vue&type=script&lang=js"
export * from "./Sidebyside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports